var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStudySmall = function SvgStudySmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "study-small_svg__a",
    width: "105.8%",
    height: "105.7%",
    x: "-2.9%",
    y: "-2.3%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0.304622592 0 0 0 0 0.578497024 0 0 0 0.129971591 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "study-small_svg__b",
    d: "M0 0h800v812H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7F8F9",
    d: "M-624-326H816V730H-624z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24 -122)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#study-small_svg__b",
    fill: "#000",
    filter: "url(#study-small_svg__a)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#study-small_svg__b",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C83133",
    d: "M4.583 20a.417.417 0 1 1 0-.833h4.583v-.834c-2.395 0-4.132-.883-5.27-1.752l-.16-.124c-.345-.268-.559-.47-.679-.624H1.25a.417.417 0 1 1 0-.833h5.833a.417.417 0 1 1 0 .833H4.362c.185.149.346.286.444.352a7.7 7.7 0 0 0 4.36 1.312c3.58 0 7.651-2.763 7.913-7.652.042-1.216-.232-2.31-.538-3.122l-6.12 6.123a1 1 0 0 1-1.3.097 1 1 0 0 1-.114.138l-.354.354a1 1 0 0 1-1.414 0l-.943-.943a1 1 0 0 1 0-1.414l.354-.354q.065-.065.139-.115a.996.996 0 0 1 .097-1.299L15.489.707a1 1 0 0 1 1.414 0l2.121 2.121a1 1 0 0 1 0 1.415l-1.826 1.825c.39.875.756 2.117.708 3.777-.113 4.895-3.92 8.057-7.906 8.447v.874h4.583a.417.417 0 1 1 0 .834zm2.774-8.804-.59.59 1.18 1.178.589-.59zm8.839-10.017-8.839 8.838 2.357 2.357 8.839-8.838z"
  }))));
};
export default SvgStudySmall;